import type { Department } from '../types'

export type DepartmentTreeNode = Department & { children: DepartmentTreeNode[] }

export function buildDepartmentTree(departments: Department[]): DepartmentTreeNode[] {
  const byId = new Map<string, DepartmentTreeNode>()
  for (const d of departments) byId.set(d.id, { ...d, children: [] })

  const roots: DepartmentTreeNode[] = []
  for (const node of byId.values()) {
    const parent = node.parentId ? byId.get(node.parentId) : undefined
    if (parent && parent.id !== node.id) parent.children.push(node)
    else roots.push(node)
  }

  const sortNodes = (nodes: DepartmentTreeNode[]) => {
    nodes.sort((a, b) => a.name.localeCompare(b.name, 'tr'))
    for (const n of nodes) sortNodes(n.children)
  }
  sortNodes(roots)
  return roots
}

export function childrenOf(id: string, departments: Department[]): Department[] {
  return departments.filter((d) => d.parentId === id).sort((a, b) => a.name.localeCompare(b.name, 'tr'))
}
